import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

import s from '@styles/hero-section.module.css';

const IMAGE_MAP = {
  pnd: { file: 'hero/pumpa.jpg', alt: 'Benzinska pumpa Keso-Promet' },
  transport: { file: 'hero/transport-kiperima.jpg', alt: 'Transport kiperima', position: 'top' },
  zitopromet: { file: 'hero/zitopromet.jpg', alt: 'Žitopromet mlin' },
  pipb: { file: 'hero/betonara.jpg', alt: 'Betonara Keso-Promet' },
  invest: { file: 'hero/keso-invest.jpg', alt: 'Stambeno-poslovni objekat Keso Invest' },
};

const HeroSection = ({ children, cn }) => (
  <StaticQuery
    query={graphql`
      query {
        allFile(filter: { relativeDirectory: { eq: "hero" } }) {
          edges {
            node {
              relativePath
              childImageSharp {
                fluid(maxWidth: 2048, quality: 80) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const config = IMAGE_MAP[cn];
      const position = (config && config.position) || 'center';
      const imageNode = config && data.allFile.edges.find(
        edge => edge.node.relativePath === config.file
      );
      const fluid = imageNode && imageNode.node.childImageSharp.fluid;

      return (
        <section className={`container-fluid ${s.heroSection}`}>
          {fluid && (
            <Img
              fluid={fluid}
              alt={config.alt}
              className={s.heroImage}
              imgStyle={{ objectPosition: position }}
            />
          )}
          <span className={s.overlay} />
          {children}
        </section>
      );
    }}
  />
);

export default HeroSection;
